export const SECONDS_PER_MINUTE = 60;
